import { sv } from '@ucheba/utils/helpers/styles/variables'
import styled from 'styled-components'

export const Image = styled.img`
  width: 80px;
  height: 78px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 64px;

  border-top: 1px solid ${sv.color.gray9};
`
